import createCachedSelector from "re-reselect";

import getItemDisplayDates from "./getItemDisplayDates";

/**
 * This function calculates the individual ItemDisplayRecord for the item passed as the first
 * parameter and caches the result to avoid re-calculating too often
 * Note: Do not change this function signature without changing getIndividualItemsWithTextSize to match
 * @param {ItemRecord} item
 * @param {CalendarRecord} calendar
 * @param {DateRecord} todayDate
 * @param {boolean} hasOngoingDescendants
 * @param {boolean} hasDescendantBeyondNow
 *
 * These values are ignored...
 * param {number} itemCardViewTextWidth
 * param {Map} characterWidthMap
 * param {boolean} isMobileMode
 * param {number} subwayLineLimit
 */
const getIndividualItemDates = createCachedSelector(
  // Use these inputs directly
  (...params) => params[0].startDate, // item.startDate
  (...params) => params[0].duration, // item
  (...params) => params[0].preferredStartDate, // item
  (...params) => params[0].preferredDuration, // item
  (...params) => params[0].latestStartDate, // item
  (...params) => params[0].durationToEarliestEnd, // item
  (...params) => params[0].ongoing, // item
  (...params) => params[1], // calendar
  (...params) => params[2], // todayDate
  (...params) => params[3], // hasOngoingDescendants
  (...params) => params[4], // hasDescendantBeyondNow
  // Final Output Calculation
  (
    startDate,
    duration,
    preferredStartDate,
    preferredDuration,
    latestStartDate,
    durationToEarliestEnd,
    ongoing,
    calendar,
    todayDate,
    hasOngoingDescendants,
    hasDescendantBeyondNow
  ) => {
    return getItemDisplayDates(
      startDate,
      duration,
      preferredStartDate,
      preferredDuration,
      latestStartDate,
      durationToEarliestEnd,
      ongoing,
      hasOngoingDescendants,
      todayDate,
      hasDescendantBeyondNow,
      calendar
    );
  }
)(item => item.id);

export default getIndividualItemDates;
